import React from "react";
import QuizContainer from "../../components/Quiz/QuizContainer";
import { QuizHeader } from "../../components/Quiz/QuizHeader";
import styled from "@emotion/styled";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../utils/api";
import { useEffect } from "react";
import { useState } from "react";
import radioChoice from "../../assets/icons/radioChoice.svg";
import radioChoiceActive from "../../assets/icons/radioChoiceActive.svg";
import radioDisabled from "../../assets/icons/radioDisabled.svg";
import useAuth from "../../utils/useAuth";
import Modal from "antd/lib/modal/Modal";
import CheckIcon from "../../assets/icons/checkWithBg.svg";

const QuizDoing = () => {
  const { group } = useParams();

  const navigate = useNavigate();

  const [quizList, setQuizList] = useState([]);
  const [userAnswers, setUserAnswers] = useState([]);
  const [topic, setTopic] = useState("");
  const [currentIndex, setCurrentIndex] = useState(undefined);
  const [doState, setDoState] = useState("do");
  const [result, setResult] = useState({ score: "-", totalFinish: "-" });

  const [showModal, setShowModal] = useState(false);

  const { isStaff } = useAuth();

  const getRadioIcon = (isUserOrCorrectAnswer) => {
    if (isUserOrCorrectAnswer) return radioChoiceActive;

    if (isStaff) return radioDisabled;

    return radioChoice;
  };

  useEffect(() => {
    api
      .get("/quiz/getTotalFinishByQuizGroup/" + group)
      .then((res) => {
        const totalFinish = res.data?.totalFinish;

        if (totalFinish === 2) {
          setShowModal(true);
          setTimeout(() => {
            navigate("/quiz", { replace: true });
          }, 3000);
        } else {
          const endpoint = isStaff
            ? "getQuizListWithRightAnswers"
            : "getQuizList";

          api
            .get(`/quiz/${endpoint}?group=${group}`)
            .then((res) => {
              if (res.status === 200) {
                const { quizMasterList, topic } = res.data;
                setQuizList(quizMasterList);
                setTopic(topic);
              }
            })
            .catch((err) => {
              alert("ไม่สามารถดึงข้อมูลแบบทดสอบได้");
            });
        }
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (quizList.length > 0) setCurrentIndex(0);
    if (!isStaff) setUserAnswers(quizList.map(() => ""));
  }, [quizList]);

  const onSubmitAnswers = () => {
    api
      .post("/quiz/updateUserAnswers", {
        userAnswers: userAnswers.map((a, i) => ({
          quizMasterId: quizList[i].quizMasterId,
          answer: a,
        })),
        group,
      })
      .then((res) => {
        if (res.status === 200) {
          const { score, totalFinish } = res.data;

          setDoState("done");
          setResult({ score, totalFinish });
        }
      })
      .catch((err) => {
        alert("ไม่สามารถส่งคำตอบได้");
      });
  };

  return (
    <QuizContainer>
      {!isNaN(currentIndex) && (
        <InnerContainer>
          <center>
            <QuizNoText>ชุดความรู้เล่มที่ {group}</QuizNoText>
            <QuizHeader>{topic}</QuizHeader>
            {doState === "done" && (
              <>
                <ScoreFinishTimeText>
                  คะแนนครั้งที่ {result.totalFinish}
                </ScoreFinishTimeText>
                <ScoreCircle>
                  <ScoreCircleText>{result.score}</ScoreCircleText>
                  <ScoreCircleText fontSize={"18px"}>คะแนน</ScoreCircleText>
                </ScoreCircle>
                <ScorePercentText>
                  {result.score * 10}&nbsp;%
                  {result.score >= 8 && <>&nbsp;ดีมาก</>}
                </ScorePercentText>
                <ActionButton
                  finishState
                  width={"240px"}
                  onClick={(e) => navigate("/quiz")}
                >
                  กลับไปหน้าแบบทดสอบ
                </ActionButton>
              </>
            )}
          </center>

          {doState === "do" && (
            <>
              <QuestionText
                dangerouslySetInnerHTML={{
                  __html: `${quizList[currentIndex].sequence}. ${quizList[currentIndex].question}`,
                }}
              />
              {quizList[currentIndex].choices.map((c, i) => (
                <ChoiceContainer
                  isActive={
                    isStaff
                      ? quizList[currentIndex].rightAnswer === c.value
                      : userAnswers[currentIndex] === c.value
                  }
                  showCorrect={
                    isStaff && quizList[currentIndex].rightAnswer === c.value
                  }
                  onClick={(e) => {
                    if (!isStaff)
                      setUserAnswers(
                        userAnswers.map((a, i) =>
                          i === currentIndex ? c.value : a
                        )
                      );
                  }}
                >
                  <RadioChoiceImg
                    src={getRadioIcon(
                      isStaff
                        ? quizList[currentIndex].rightAnswer === c.value
                        : userAnswers[currentIndex] === c.value
                    )}
                  />
                  {c.value}
                  {")"} {c.label}
                </ChoiceContainer>
              ))}
              <ActionContainer>
                <ActionButton
                  disabled={currentIndex - 1 < 0}
                  onClick={(e) => setCurrentIndex(currentIndex - 1)}
                >
                  กลับ
                </ActionButton>
                {!isStaff && currentIndex + 1 === quizList.length ? (
                  <ActionButton
                    onClick={(e) => onSubmitAnswers()}
                    disabled={!userAnswers[currentIndex]}
                    fontWeight={"700"}
                    finishState
                  >
                    ส่งคำตอบ
                  </ActionButton>
                ) : (
                  <ActionButton
                    onClick={(e) => setCurrentIndex(currentIndex + 1)}
                    fontWeight={"700"}
                    disabled={
                      isStaff
                        ? currentIndex + 1 === quizList.length
                        : !userAnswers[currentIndex]
                    }
                  >
                    ข้อต่อไป
                  </ActionButton>
                )}
              </ActionContainer>
            </>
          )}
        </InnerContainer>
      )}

      <Modal
        visible={showModal}
        closable={true}
        footer={null}
        onCancel={() => setShowModal(false)}
        style={{
          fontFamily: `"Noto Sans Thai", "Noto Sans"`,
        }}
      >
        <center>
          <img src={CheckIcon} width="144px" height="144px" />
          <br />
          <div style={{ marginTop: "16px" }}>
            <span
              style={{
                fontSize: "20px",
                color: "#058459",
                fontWeight: "600",
              }}
            >
              ทำแบบทดสอบเล่มนี้ครบ 2 ครั้งแล้ว
            </span>
            <br />
            <span style={{ fontSize: "18px", color: "#4B5768" }}>
              คุณสามารถเลือกแบบทดสอบเล่มอื่น ๆ เพื่อดำเนินการต่อ
            </span>
          </div>
        </center>
      </Modal>
    </QuizContainer>
  );
};

export default QuizDoing;

const InnerContainer = styled.div`
  width: 100%;
  max-width: 440px;
  margin: auto;
`;

const ActionButton = styled.button`
  width: ${(props) => (props.width ? props.width : "150px")};
  padding: 14px 0px;
  border: 1px solid ${(props) => (props.disabled ? "#d0d5dd" : "#16AF7B")};
  border-radius: 100px;
  background: ${(props) =>
    props.disabled ? "#f7f8f9" : props.finishState ? "#16AF7B" : "#B5F6DF"};
  margin-top: 32px;
  cursor: pointer;
  color: ${(props) =>
    props.disabled ? "#d0d5dd" : props.finishState ? "white" : "#16AF7B"};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 600)};
  font-size: 20px;
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const RadioChoiceImg = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 10px;
`;

const QuestionText = styled.p`
  font-family: "Noto Sans Thai";
  font-weight: 400;
  font-size: 18px;
  color: #4b5768;

  br.br-mobile {
    display: none;
  }

  @media (max-width: 437px) {
    br.br-mobile {
      display: unset;
    }
  }
  @media (max-width: 378px) {
    br.br-mobile {
      display: none;
    }
  }
`;

const QuizNoText = styled.p`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #4b5768;
  margin-bottom: 4px;
`;

const ChoiceContainer = styled.div`
  padding: 16px;
  border: 1px solid ${(props) => (props.isActive ? "#058459" : "#b8c0cc")};
  cursor: pointer;
  margin-bottom: 8px;
  font-size: 18px;
  background: ${(props) => (props.showCorrect ? "#B5F6DF" : "white")};
  color: ${(props) => (props.isActive ? "#058459" : "#4b5768")};
`;

const ScoreCircle = styled.div`
  width: 213px;
  height: 214px;
  padding: 40px;

  background: #fc6b4b;
  border-radius: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ScoreFinishTimeText = styled.p`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #4b5768;
  margin-bottom: 12px;
`;

const ScoreCircleText = styled.span`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "80px")};
  color: #ffffff;
  margin-top: -25px;
`;

const ScorePercentText = styled.p`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  color: #ef4444;
  margin-top: 12px;
  margin-bottom: 0px;
`;
